// extracted by mini-css-extract-plugin
export var baselineIcon = "_c0UdXUNlXaKD5lOLGRD";
export var container = "FCBlabfRczqonCwiRnLA";
export var icon = "_qpz5NwnFYZzUs9QOcQE";
export var passengerName = "GoSx9XHxboaPnJCCnsNw";
export var seatGrid = "T6m0tC2IFHXUXSNMyNal";
export var splitSaveContainer = "OkffZP99VwZTEfxZ1kna";
export var summary = "wHSLMZT4ESUEYR7h9ZvJ";